import React, { useMemo, useState } from 'react';

import { MobileOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import AppSetupModal from './AppSetupModal';

const TriggerWrapper = styled.div`
  text-align: center;
  margin-top: 12px;
`;

const readConfig = () => {
  const node = document.getElementById('app-setup-config');
  if (!node) return null;
  try {
    const parsed = JSON.parse(node.textContent);
    if (!parsed.deeplink_host || !parsed.organization_name) return null;
    return {
      host: parsed.deeplink_host,
      organizationName: parsed.organization_name,
      workspace: parsed.workspace || null,
    };
  } catch (err) {
    console.error('Failed to parse #app-setup-config:', err);
    return null;
  }
};

const AppSetupTrigger = () => {
  const { t } = useTranslation();
  const config = useMemo(readConfig, []);
  const [modalOpen, setModalOpen] = useState(false);

  if (!config) return null;

  return (
    <TriggerWrapper>
      <Button type="link" icon={<MobileOutlined />} onClick={() => setModalOpen(true)}>
        {t('operator.login.app_setup.trigger')}
      </Button>
      <AppSetupModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        host={config.host}
        organizationName={config.organizationName}
        workspace={config.workspace}
      />
    </TriggerWrapper>
  );
};

export default AppSetupTrigger;
